export default __webpack_public_path__ + "static/media/go-no-go.1d03c8eb.svg";